import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environment/environment';

export interface LogEntry {
  id: string;
  entity: string;
  operationType: string;
  userEmail: string;
  changeDetails: string;
  createdAt: string;
}

export interface LogListResponse {
  data: LogEntry[];
  total: number;
}

@Injectable({ providedIn: 'root' })
export class LogService {
  private endpoint = environment.apiEndpoint;
  
  constructor(private http: HttpClient) {}

  getLogs(
    limit?: number, 
    offset?: number, 
    orderColumn?: string, 
    orderDirection?: 'asc' | 'desc',
    filters?: { [key: string]: any }
  ): Observable<LogListResponse> {
    let url = `${this.endpoint}/v1/logs/list`;
    const params = new URLSearchParams();
    
    if (limit !== undefined) params.append('limit', limit.toString());
    if (offset !== undefined) params.append('offset', offset.toString());
    if (orderColumn) params.append('orderColumn', orderColumn);
    if (orderDirection) params.append('orderDirection', orderDirection);
    
    if (filters) {
      Object.keys(filters).forEach(key => {
        if (filters[key] !== null && filters[key] !== undefined) {
          if (Array.isArray(filters[key]) && filters[key].length > 0) {
            const filterObj = filters[key][0];
            if (filterObj && filterObj.value !== null && filterObj.value !== undefined && filterObj.value !== '') {
              params.append(key, filterObj.value);
            }
          }

          else if (typeof filters[key] === 'object' && filters[key].value !== null && filters[key].value !== undefined) {
            params.append(key, filters[key].value);
          }
        }
      });
    }
    
    const queryString = params.toString();
    if (queryString) {
      url += `?${queryString}`;
    }
    
    return this.http.get<LogListResponse>(url);
  }

  exportAllLogsAsCsv(filters?: { [key: string]: any }): Observable<LogListResponse> {
    return this.getLogs(1000, 0, undefined, undefined, filters);
  }
}
